// Quiz question definitions used by the Paddle Finder UI.
// Icons come from lucide-react.

export const QUESTIONS = [
  {
    id: "experience",
    title: "How would you rate your game?",
    hint: "We tune recommendations to your level.",
    options: [
      { id: "beginner", label: "Beginner", sub: "Just picking up a paddle", icon: "Sprout" },
      { id: "intermediate", label: "Intermediate", sub: "Play weekly, work on shots", icon: "Zap" },
      { id: "advanced", label: "Advanced", sub: "Tournaments, strategic play", icon: "Trophy" },
      { id: "not_sure", label: "Not sure", sub: "Show me safe picks", icon: "HelpCircle" },
    ],
  },
  {
    id: "weight_pref",
    title: "How heavy do you like your paddle?",
    hint: "Lighter = quicker hands • Heavier = more pop.",
    options: [
      { id: "light", label: "Light", sub: "Under 7.6 oz", icon: "Feather" },
      { id: "medium", label: "Medium", sub: "7.6 – 8.2 oz", icon: "Scale" },
      { id: "heavy", label: "Heavy", sub: "Over 8.2 oz", icon: "Dumbbell" },
      { id: "not_sure", label: "Not sure", sub: "Recommend for me", icon: "HelpCircle" },
    ],
  },
  {
    id: "grip",
    title: "What grip size fits your hand?",
    hint: "Not sure? Measure ring-finger tip to bottom crease.",
    options: [
      { id: "small", label: "Small", sub: "4 – 4 1/8 in", icon: "Hand" },
      { id: "medium", label: "Medium", sub: "4 1/4 in", icon: "Hand" },
      { id: "large", label: "Large", sub: "4 3/8 – 4 1/2 in", icon: "Hand" },
      { id: "not_sure", label: "Not sure", sub: "Open grip guide", icon: "HelpCircle", opensGuide: true },
    ],
  },
  {
    id: "play_style",
    title: "How do you like to play?",
    hint: "Pick the vibe that describes your rallies.",
    options: [
      { id: "control", label: "Control", sub: "Dinks, resets, placement", icon: "Target" },
      { id: "power", label: "Power", sub: "Smashes, drives, aggression", icon: "Flame" },
      { id: "versatile", label: "Versatile", sub: "A bit of everything", icon: "Shuffle" },
    ],
  },
  {
    id: "primary_goal",
    title: "Where do you want to level up?",
    hint: "We'll match paddles built for that shot.",
    options: [
      { id: "dink_control", label: "Dinking & control", icon: "MousePointer" },
      { id: "volley_net", label: "Volleys at the net", icon: "Swords" },
      { id: "baseline_power", label: "Baseline power", icon: "Rocket" },
      { id: "serve_return", label: "Serve & return", icon: "CornerUpRight" },
    ],
  },
  {
    id: "performance_priority",
    title: "What matters most to you?",
    hint: "Choose the single trait you value most.",
    options: [
      { id: "control", label: "Control", icon: "Target" },
      { id: "power", label: "Power", icon: "Flame" },
      { id: "spin", label: "Spin", icon: "RotateCw" },
      { id: "comfort", label: "Comfort", icon: "Feather" },
    ],
  },
  {
    id: "budget",
    title: "What's your budget?",
    hint: "We'll only show paddles that fit.",
    options: [
      { id: "under_80", label: "Under $80", icon: "DollarSign" },
      { id: "80_150", label: "$80 – $150", icon: "DollarSign" },
      { id: "over_150", label: "$150+", icon: "DollarSign" },
      { id: "no_limit", label: "No limit", icon: "Sparkles" },
    ],
  },
];

export const DEFAULT_ANSWERS = {
  experience: "not_sure",
  weight_pref: "not_sure",
  grip: "medium",
  play_style: "versatile",
  primary_goal: "dink_control",
  performance_priority: "control",
  budget: "no_limit",
};

// Cart permalink pattern for Shopify: /cart/{variant_id}:{qty}
export const SHOPIFY_DOMAIN_DEFAULT = "https://clubdinksupply.com";
export const shopDomain = () =>
  (typeof window !== "undefined" && window.__CD_SHOP_DOMAIN__) || SHOPIFY_DOMAIN_DEFAULT;
export const cartPermalink = (variantId, qty = 1) =>
  `${shopDomain()}/cart/${variantId}:${qty}`;
